import { useState } from "react";
import Logo from "./Logo";
import Form from "./Form";
import PackingList from "./PackingList";
import Stats from "./Stats";

export default function App() {
  const [items, setItems] = useState([]);

  const handleAddItem = (item) => setItems((prevItems) => [...prevItems, item]);

  const handleDeleteItem = (id) =>
    setItems((prevItems) => prevItems.filter((item) => item.id !== id));

  const handleToggleItem = (id) =>
    setItems((prevItems) =>
      prevItems.map((item) =>
        item.id === id ? { ...item, packed: !item.packed } : item
      )
    );

  const handleClearItems = () => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete all items?"
    );
    if (isConfirmed) setItems([]);
  };

  return (
    <div className="app">
      <Logo />
      <Form onAddItems={handleAddItem} />
      <PackingList
        items={items}
        onDeleteItems={handleDeleteItem}
        onToggleItems={handleToggleItem}
        onClearItems={handleClearItems}
      />
      <Stats items={items} />
    </div>
  );
}
